import { ImageDialog } from "../image-dialog/ImageDialog";
import type { FileItem } from "../../types";

interface FileExplorerImageDialogProps {
  imageFile: FileItem | null;
  isOpen: boolean;
  allFiles: FileItem[];
  onOpenChange: (open: boolean) => void;
  onNavigate: (direction: "prev" | "next") => void;
}

export function FileExplorerImageDialog({
  imageFile,
  isOpen,
  allFiles,
  onOpenChange,
  onNavigate,
}: FileExplorerImageDialogProps) {
  if (!imageFile) {
    return null;
  }

  return (
    <ImageDialog
      open={isOpen}
      onOpenChange={onOpenChange}
      file={imageFile}
      files={allFiles}
      onNavigate={onNavigate}
    />
  );
}

